<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label name="keywords">
          <a-input-group compact :style="{ width: '360px' }">
            <a-select v-model:value="search.key_type" style="width: 30%" @change="inputSelect">
              <a-select-option value="author">发放者</a-select-option>
              <a-select-option value="description">红包说明</a-select-option>
              <a-select-option value="use_description">使用说明</a-select-option>
              <a-select-option value="amount">红包余额</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索" />
          </a-input-group>
        </a-form-item>
        <a-form-item label="最近状态更新时间" name='time'>
          <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
        </a-form-item>
        <a-form-item label="红包类型" name='bonus_type'>
          <a-select v-model:value="search.bonus_type" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">企业零钱红包</a-select-option>
            <a-select-option :value="2">现金红包</a-select-option>
            <a-select-option :value="3">代发红包</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="发放状态" name='send_status'>
          <a-select v-model:value="search.send_status" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">发放成功</a-select-option>
            <a-select-option :value="2">发放失败</a-select-option>
            <a-select-option :value="3">补发成功</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="发放渠道" name='send_apply' >
          <a-select v-model:value="search.send_apply" :style="{width:'140px'}" placeholder="全部">
            <a-select-option value="">全部</a-select-option>
            <a-select-option :value="1">会员卡生日权益</a-select-option>
            <a-select-option :value="2">扫码奖品</a-select-option>
            <a-select-option :value="7">夺宝失败</a-select-option>
            <a-select-option :value="5">门店派送</a-select-option>
            <a-select-option :value="6">拼团团长奖励</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item >
          <a-button type="primary" htmlType='submit' class="m-r-10">搜索</a-button>
            <a-button type="primary" v-has:redAllReissue="reissue">一键全部补发</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='data'>
           <template v-slot:send_status="{ record }">
              <p v-if="record.send_status==2">{{record.send_status_text}} <a-tooltip placement='right'>
              <template #title>{{record.return_msg}}
              </template>
              <QuestionCircleOutlined class="s_c376" />
            </a-tooltip> </p>
              <p v-else>{{record.send_status_text}}</p>
            </template>
          <template #user="{ record }">
            <p>{{record.member_name}}</p>
            <p>{{record.id}}</p>
          </template>
        <template v-slot:action="{ record }">
          <a-button v-has:redAllReissue="()=>{signReissue(record)}" v-if="record.send_status!=1">补发红包</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </a-card>
  </a-layout>
</template>
<script>
import { ref, onMounted, reactive, toRefs,h} from "vue";
import { message, Modal } from "ant-design-vue";
import { getBonusSendList,reissueBonus } from "@/api/red";
import { iscode } from "@/utils/app";
  import { QuestionCircleOutlined } from "@ant-design/icons-vue";
// 初始化默认筛选项数值
let defSearch = {
  page: 1,
  limit: 10,
  bonus_type: "",
  send_apply: "",
  start_time: "",
  end_time: "",
  send_status: "",
  key_type: "author",
  keyword: "",
};
export default {
  components:{QuestionCircleOutlined},
  setup(props, ctx) {
    // // 初始化 分页信息和筛选项信息
    let search = ref({ ...defSearch });
    // 列表数据和列头配置
    let data = ref([]);
    const state = reactive({
      list: [],
      listLoading: false,
      time: [],
      total: 1,
      level: null,
    });
    let columns = [
      {
        title: "发放对象昵称",
        dataIndex: "user",
        key: "user",
         slots: { customRender: "user" }
      },
      {
        title: "红包类型",
        dataIndex: "bonus_type_text",
        key: "bonus_type_text"
      },
      {
        title: "红包金额",
        dataIndex: "bonus_amount",
        key: "bonus_amount",
      },
      {
        title: "红包ID",
        dataIndex: "bonus_id",
        key: "bonus_id",
      },
      {
        title: "发放状态",
        dataIndex: "send_status_text",
        key: "send_status_text",
        slots: { customRender: "send_status" },
      },
      {
        title: "发放渠道",
        dataIndex: "send_apply_text",
        key: "send_apply_text",
      },
      {
        title: "微信业务单号",
        dataIndex: "billno",
        key: "billno",
      },
      {
        title: "最近状态更新时间",
        dataIndex: "update_time",
        key: "update_time",
      },
         {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
      
    ];
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    // 时间筛选
    const onChange = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
      initData(search.value);
    };
    const initData = async () => {
      state.listLoading = true;
      data.value = [];
      try {
        let res = await getBonusSendList(search.value).then((res) => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          data.value = res.data.data;
          state.total = res.data.total;
        } else {
          message.error(res.msg);
        }
      } catch (e) {
        state.listLoading = false;
      }
    };
    onMounted(() => {
      initData(search.value);
    });
    const inputSelect = (e) => {
      search.value.keywords = "";
    };
    // 补发
    const reissue=()=>{
      Modal.confirm({
          centered: true,
          title:'温馨提示',
          content: "确定要一键补发全部红包么?",
          onOk: async () => {
            let res = await reissueBonus().then((res) => res.data).catch(error => error);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
    }
    // 独立补发
    const signReissue=(data)=>{
        Modal.confirm({
          centered: true,
          title:'温馨提示',
          content: "确定要补发红包么?",
          onOk: async () => {
            let res = await reissueBonus({key:data.key}).then((res) => res.data).catch(error => error);
            if (iscode(res, true)) {
              initData();
            }
          },
        });
    }
    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      inputSelect,
      reissue,
      signReissue
    };
  },
};
</script>